import config from "../../config";

function authHeader() {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user && user.key) {
    return { Authorization: "Token  " + user.key };
  }
  return {};
}

const BASE = config.apiGateway.URL + "/clinics/admin/predetermination-rules/";

async function request(url, method) {
  const res = await fetch(new Request(url, {
    method: method || "GET",
    headers: Object.assign({ "Content-Type": "application/json" }, authHeader()),
  }));
  let json = null;
  try {
    json = await res.json();
  } catch (e) {
    json = null;
  }
  return { json, status: res.status };
}

export const getRules = (status) => request(BASE + (status ? "?status=" + encodeURIComponent(status) : ""));
export const approveRule = (id) => request(BASE + id + "/approve/", "POST");
export const disableRule = (id) => request(BASE + id + "/disable/", "POST");
export const learnForOffice = (officeId) => request(BASE + "learn/?office_id=" + encodeURIComponent(officeId), "POST");
